module.exports = __webpack_public_path__ + "img/Ora-Ani_Bruecke_2kl.50de2292.jpg";